import React from "react";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import { PERMISSION_IDS } from "../../constant";

const ProductImageName = ({
  parent_classname,
  img_classname,
  img_url,
  img_alt,
  text,
  btnOnClick,
}) => {
  const [imgLoaded, setImgLoaded] = React.useState(false);
  const { is_sales_manager, is_admin, permission_ids } = useSelector((state) => state.auth);
  const [isError, setIsError] = React.useState(false);

  return (
    <div className={`flex items-center ${parent_classname}`}>
      <div className="relative group h-full">
        {/* Loader while image loads */}
        {!imgLoaded && (
          <div className="absolute inset-0 flex justify-center items-center bg-gray-100 rounded">
            <Loader size="small" />
          </div>
        )}
        <img
          src={
            isError
              ? "/assets/images/place_holder_image1.svg"
              : img_url || "/assets/images/place_holder_image1.svg"
          }
          alt={img_alt || "Product"}
          className={`w-14 h-14 min-w-14 min-h-14 object-cover rounded transition-opacity duration-300 ${
            imgLoaded ? "opacity-100" : "opacity-0"
          } ${img_classname}`}
          onLoad={() => setImgLoaded(true)}
          onError={() => {
            setImgLoaded(true);
            setIsError(true);
          }}
        />
        {(is_sales_manager || is_admin || permission_ids.includes(PERMISSION_IDS.IMAGE_EDITING)) && btnOnClick && (
          <button
            className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all rounded"
            onClick={btnOnClick}
          >
            <img src="/assets/icons/Pencil.png" alt="Edit" className="w-5 h-5" />
          </button>
        )}
      </div>
      <span className="font-manrope font-semibold text-[14px] leading-[120%] tracking-[0%] text-black pl-2">
        {text}
      </span>
    </div>
  );
};

export default ProductImageName;
